var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12 .75H3c-.825 0-1.5.675-1.5 1.5v10.5H3V2.25h9zm2.25 3H6c-.825 0-1.5.675-1.5 1.5v10.5c0 .825.675 1.5 1.5 1.5h8.25c.825 0 1.5-.675 1.5-1.5V5.25c0-.825-.675-1.5-1.5-1.5m0 12H6V5.25h8.25z"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxOCIgaGVpZ2h0PSIxOCIgZmlsbD0ibm9uZSI+PHBhdGggZmlsbD0iY3VycmVudENvbG9yIiBkPSJNMTIgLjc1SDNjLS44MjUgMC0xLjUuNjc1LTEuNSAxLjV2MTAuNUgzVjIuMjVoOXptMi4yNSAzSDZjLS44MjUgMC0xLjUuNjc1LTEuNSAxLjV2MTAuNWMwIC44MjUuNjc1IDEuNSAxLjUgMS41aDguMjVjLjgyNSAwIDEuNS0uNjc1IDEuNS0xLjVWNS4yNWMwLS44MjUtLjY3NS0xLjUtMS41LTEuNW0wIDEySDZWNS4yNWg4LjI1eiIvPjwvc3ZnPg==";
export { SvgCopy as ReactComponent };